// extracted by mini-css-extract-plugin
export default {"PageNotFound":"PageNotFound3u7_0vlmK5-A","PageNotFound-logo":"PageNotFound-logoJythb8vq2xAB","PageNotFound-title":"PageNotFound-titlevy1rat2lG86f"};